import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { MediaContext } from '@playbookux/playbook-web-core';
import Portal from '../portal';
import { Container } from './styles';

// TODO find a better way to determine children size
const WIDTH = 300;
const BOTTOM_OFFSET = 305;
const BOTTOM_OFFSET_FULL_SCREEN = 250;

const getScrollParent = (parent, child) => {
  let element = child;
  let scrollTop = 0;
  while (element && element !== parent) {
    element = element.parentElement;
    scrollTop += element.scrollTop;
  }
  return scrollTop;
};

const Modal = ({ anchorTime, children }) => {
  const { player, media: { playerRect } } = useContext(MediaContext);

  const [positionX, setPositionX] = useState(0);
  const [positionY, setPositionY] = useState(0);

  useEffect(() => {
    const { seekBar } = player.controlBar.progressControl;
    const seekBarEl = seekBar.el();
    const duration = player.duration();
    const box = seekBarEl.getBoundingClientRect();
    let anchorX = box.left + box.width * (anchorTime / duration) - WIDTH / 2;
    const scrolled = getScrollParent(document.documentElement, player.el());
    // Cap to window size.
    anchorX = Math.max(Math.min(anchorX, box.right - WIDTH), box.left);

    const { isFullscreen_: isFullScreen } = player;
    const bottomOffset = isFullScreen ? BOTTOM_OFFSET_FULL_SCREEN : BOTTOM_OFFSET;

    setPositionY(box.top - bottomOffset + scrolled);
    setPositionX(anchorX);
  }, [player, anchorTime, playerRect]);

  return (
    <Portal>
      <Container style={{ left: positionX, top: positionY }}>
        {children}
      </Container>
    </Portal>
  );
};

Modal.propTypes = {
  anchorTime: PropTypes.number.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

Modal.defaultProps = {
  children: null,
};

export default Modal;
